import { FloorplanToolBase } from './FloorplanToolBase';
import { ViewModes } from '../../helpers';
import type { IViewConfig } from '../../types';

export class RoomSelectionTool extends FloorplanToolBase {

  /** Tab selection tool: show the floors elevation map for orientation/switching. */
  protected showsFloorBars(): boolean {
    return true;
  }
  readonly name = 'room_selection';

  getViewConfig(): IViewConfig {
    return {
      views: [ViewModes.XRAY_2D, ViewModes.PERSPECTIVE_3D_RGB],
      defaultViewId: ViewModes.XRAY_2D.id,
    };
  }
}
